import React from 'react'
import { useNavigate } from 'react-router-dom'
import projectData from './Project.json'
import './Project.css'

const ProjectCards = () => {
  const navigate = useNavigate()
  const projects = projectData.projects

  return (
    <div className='backdiv'>
    <div className="projects-grid">
      {projects.map((project) => (
        <div key={project.id} className="project-card" onClick={() => navigate(`/projects/${project.id}`)}>
            <div className='proj-image-div'>
          <img className='img-cover' src={project.image} alt={project.name} loading='lazy' />
          </div>
          <div className='proj-card-content'>
            <div>
          <h3 className='project_heading'>{project.name}</h3>
          <p className='project_subheading'>{project.location}</p>
          </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  )
}

export default ProjectCards
